import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

const AssetListHeader = ({ sortOrder, handlesort, sortKey, orderby }: any) => {
  const [activeHead, setActiveHead] = useState(sortKey);
  const handleclick = (val: any) => {
    handlesort(sortOrder);
    setActiveHead(val);
    orderby(val);
  };
  //   useEffect(() =>{
  //     orderby(activeHead);
  // }, [sortOrder])
  //   useEffect(() =>{
  //     orderby(sortKey);
  // }, [sortKey])
  return (
    <thead className="asset-list-header ">
      <tr>
        <th
          style={{
            textAlign: "center",
            width: "30px",
          }}
        ></th>
        <th
          style={{
            textAlign: "left",
            margin: "5px",
          }}
          onClick={() => handleclick("asset_name")}
        >
          Coin/Asset
          {sortKey === "asset_name" ? (
            <div
              className={
                sortOrder === "ascn"
                  ? "table-head-name-arrow table-sort-arrow"
                  : "table-sort-arrow"
              }
            >
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          ) : (
            <></>
          )}
        </th>
        <th onClick={() => handleclick("Balance")}>
          Balance
          {sortKey === "Balance" ? (
            <div
              className={
                sortOrder === "ascn"
                  ? "table-head-name-arrow table-sort-arrow"
                  : "table-sort-arrow"
              }
            >
              <FontAwesomeIcon icon={faCaretDown} />
            </div>
          ) : (
            <></>
          )}
        </th>
        {/* <th></th> */}
        <th className="action-head" style={{ textAlign: "end" }}>
          Actions
        </th>
      </tr>
    </thead>
  );
};

export default AssetListHeader;
